import { io } from "socket.io-client";

export const socket = io(process.env.REACT_APP_SOCKET_URL, {
    transports: ["websocket"],
    autoConnect: false
});

export function connectSocket() {

    const token = localStorage.getItem("token");

    if (!token) {
        return;
    }

    socket.auth = {
        token
    };

    if (!socket.connected) {
        socket.connect();
    }
}

export function disconnectSocket() {

    if (socket.connected) {
        socket.disconnect();
    }

}